export default class KeyProcessor {
  constructor(actions, context) {
    this.actions = actions

    this.processKey = this.processKey.bind(this)
    window.addEventListener('keydown', this.processKey)
  }

  processKey({ keyCode }) {
    const action = this.actions[keyCode]
    if (action) {
      action()
    }
  }

  removeListener() {
    window.removeEventListener('keydown', this.processKey)
  }
}
